<template lang="html">
  <div class="m-input-group form-group">
    <label v-if="label" for="">{{ label }}</label>
    <input
      class="form-control"
      @input="$emit('input', ivalue)"
      @keyup="$emit('keyup')"
      :type="type || 'text'"
      :placeholder="placeholder"
      v-model="ivalue">
    <div v-if="errors.length > 0"
      v-for="(message, index) in errors"
      :key="index + message"
      class="text-danger">
      {{ message }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String | null,
    type: String | null,
    name: String | null,
    placeholder: String | null,
    value: String,
    errors: { type: Array, default: () => [] }
  },

  data: () => ({
    ivalue: ''
  }),

  watch: {
    value (val) {
      this.ivalue = val
    }
  },

  mounted () {
    this.ivalue = this.value
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/ui/forms/InputGroup.vue